import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/config");
export var getCurrencyConfig = function getCurrencyConfig() {
  return getReq("".concat(BASE_URL, "/currency"));
};